module.exports = __webpack_public_path__ + "static/design-1-2a7ccff753e59b7ba5ca71715fbfb71e.png";